/*
|--------------------------------------------------------------------------
| Utilities: Fetch
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.utilities.fetch = {
	"init": function(){
		this.html.init();
		this.view.init();
	}
};